/** @format */

import { Card } from "antd";
import CreatePasswordForm from "./CreatePasswordForm";
import { ICreatePasswordFormProps } from "./CreatePasswordForm/CreatePasswordForm.types";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface IProps {
	createPasswordFormProps?: ICreatePasswordFormProps;
	doRedirect: boolean;
	resetTokenIsValid: boolean;
}

const CreatePasswordContentView: React.FC<IProps> = ({
	createPasswordFormProps,
	doRedirect,
	resetTokenIsValid,
}) => {
	const navigate = useNavigate();

	useEffect(() => {
		if (doRedirect) {
			navigate("/");
		}
	}, [doRedirect, navigate]);

	return (
		<div>
			{createPasswordFormProps && resetTokenIsValid && (
				<Card title="Create password">
					<CreatePasswordForm {...createPasswordFormProps} />
				</Card>
			)}
		</div>
	);
};

export default CreatePasswordContentView;
